import { GetLogs } from "./getLogs";
import { DEFAULT_PAGE } from "../../contstants";
import getDateRange from "../../utils/getDateRange";

const FilterLogs = async (perPage, filters) => {
  const page = filters.page || DEFAULT_PAGE;
  const statusCode = filters.statusCode || "";
  const { dateFrom, dateTo } = getDateRange(filters.date);
  const action = filters.action;

  const searchPhrase = filters.s;
  const searchInFields = filters.search_in_fields || "";
  let email = searchInFields.includes("email") ? searchPhrase : "";
  const request = searchInFields.includes("in_request") ? searchPhrase : "";

  // Search in email by default
  if (!email && !request && filters.s) {
    email = searchPhrase;
  }
  return await GetLogs({
    limit: perPage,
    page: page,
    statusCode: statusCode,
    dateFrom: dateFrom,
    dateTo: dateTo,
    email: email,
    request: request,
    action: action,
  });
};

export default FilterLogs;
